import React, { useEffect, useState } from "react";
import Table from "../EntryFile/datatable";
import Chart from "react-apexcharts";
import { Helmet } from "react-helmet";
import { CalendarArrowDown, CalendarClock, Loader, MessageCircleQuestion, Users } from "lucide-react";
import { getAppointmentsForCurrentWeek, getDashboardCounts, getLatestAppointments } from "../core/api/dashboard";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Dashboard = () => {
  const [counts, setCounts] = useState({});
  const [latestAppointments, setLatestAppointments] = useState([]);
  const [weeklyAppointments, setWeeklyAppointments] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [countsData, latestAppointmentsData, weeklyAppointmentsData] = await Promise.all([
          getDashboardCounts(),
          getLatestAppointments(),
          getAppointmentsForCurrentWeek(),
        ]);

        setCounts(countsData?.data || {});
        setLatestAppointments(latestAppointmentsData?.data?.latestAppointments || []);
        setWeeklyAppointments(weeklyAppointmentsData?.data || []);

        console.log("Weekly Appointments", weeklyAppointmentsData?.data);
        console.log("Latest Appointments", latestAppointments);
        console.log("Dashboard Counts", countsData?.data);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const Usersstate = {
    series: [{
      name: 'Appointments',
      data: weeklyAppointments.map(appointment => appointment.count),
    }],
    options: {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'text',
        categories: weeklyAppointments.map(appointment => new Date(appointment.date).toLocaleDateString()),
      },
    },
  };

  const columns = [
    {
      title: "Patient Name",
      dataIndex: "patient",
      render: (patient) => (
        <span>{patient?.firstName} {patient?.surname}</span>
      ),
    },
    {
      title: "Appointment Date",
      dataIndex: "appointmentDate",
      render: (appointmentDate) => (
        <span>{new Date(appointmentDate).toLocaleDateString()}</span>
      ),
      sorter: (a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate),
    },
    {
      title: "Appointment Time",
      dataIndex: "appointmentTime",
      render: (appointmentTime) => (
        <span>{appointmentTime}</span>
      ),
    },
    {
      title: "Service Provided",
      dataIndex: "services",
      render: (services) => (
        <span>{services?.length ? services[0]?.name : ""}</span>
      ),
    },
    {
      title: "Consulting Doctor",
      dataIndex: "employee",
      render: (employee) => (
        <span>{employee?.firstName} {employee?.lastName}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (status) => (
        <span className={`status-${status?.toLowerCase()}`}>{status}</span>
      ),
      filters: [
        { text: 'Confirmed', value: 'confirmed' },
        { text: 'Closed', value: 'closed' },
        { text: 'Cancelled', value: 'cancelled' },
        { text: 'Pending', value: 'pending' },
      ],
      onFilter: (value, record) => record.status === value,
    },
  ];

  return (
    <>
      <div className="page-wrapper">
        <Helmet>
          <title>Prime Precision Imaging | Dashboard</title>
          <meta name="description" content="Dashboard page" />
        </Helmet>
        <div className="content">
          <div className="row">
            
            <>
              <div className="col-lg-3 col-sm-6 col-12 d-flex">
                <div className="dash-count">
                  <div className="dash-counts">
                    <h4>{counts?.totalAppointments || 0}</h4>
                    <h5>Appointments</h5>
                  </div>
                  <div className="dash-imgs">
                    <CalendarClock size={30} />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 col-12 d-flex">
                <div className="dash-count das1">
                  <div className="dash-counts">
                    <h4>{counts?.upcomingAppointments || 0}</h4>
                    <h5>Upcoming Appointments</h5>
                  </div>
                  <div className="dash-imgs">
                    <CalendarArrowDown size={30} />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 col-12 d-flex">
                <div className="dash-count das3">
                  <div className="dash-counts">
                    <h4>{counts?.totalPatients || 0}</h4>
                    <h5>Patients</h5>
                  </div>
                  <div className="dash-imgs">
                    <Users size={30} />
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6 col-12 d-flex">
                <div className="dash-count das2">
                  <div className="dash-counts">
                    <h4>{counts?.totalEnquiries || 0}</h4>
                    <h5>Contact Enquiries</h5>
                  </div>
                  <div className="dash-imgs">
                    <MessageCircleQuestion size={30} />
                  </div>
                </div>
              </div>
            </>
            
          </div>

          {/* Latest Appointments */}
          <div className="row">
            <div className="col-lg-12 col-sm-12 col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-body p-1">
                  <h4 className="ps-3 pt-3 card-title">Appointments Overview</h4>
                  
                  <Chart
                    options={Usersstate.options}
                    series={Usersstate.series}
                    type="area"
                    height={350}
                  />
                  
                </div>
              </div>
            </div>

            <div className="col-lg-12 col-sm-12 col-12 d-flex">
              <div className="card flex-fill">
                <div className="card-body p-1">
                  <h4 className="ps-3 pt-3 card-title">Latest Appointments</h4>
                  <div className="table-responsive">
                    
                      <Table
                        columns={columns}
                        fetchData={() => { }}
                        response={{
                          data: latestAppointments,
                          totalDataCount: latestAppointments.length,
                        }}
                        NoPagination={true} // You can enable pagination if needed
                        onRowClick={(record) => history.push(`view-appointment/${record.id}`)}
                      />
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;